import { useParams } from "react-router-dom";
import { useState, useEffect, React  } from 'react';
import { blogData } from "./BlogData";
import { base_url_url } from "../igtComponant/Links";
import {Helmet} from "react-helmet";

const SingleBlog = () =>{
    const params = useParams();

    const [blogItem, setBlog] = useState([]);

    useEffect(() => {
        setBlog(blogData['blog'][params.id-1])
    }, []);
    
    return(
        <> 
          <Helmet>
             <base href={process.env.PUBLIC_URL}> </base>
             <title>{blogItem.title}</title>
             <link rel="canonical" href={`${process.env.PUBLIC_URL}/blog/${blogItem.id}`}></link>
             <meta name="description" content="IGT" />
             <meta name="keywords" content="IGT" />
             <meta name="author" content="IGT" />  
          </Helmet>  
            <section className="singleBlogWrapper">
                <div className="blog-header container">
                    <div className="blog-shap"></div>
                    <div className="blogHeaderContent">
                        <div className="image-section">
                            <img src={process.env.PUBLIC_URL + "/images/"+blogItem.image} alt={blogItem.title} title={blogItem.title} width="auto" height="auto" /> 
                        </div>
                        <div className="content-section">
                            <h2>{blogItem.title}</h2>
                            <p><span className="fa fa-calendar"></span> {blogItem.date}</p>
                        </div>
                    </div> 
                </div>


                <div className="container">
                    <div className="blog-bottom-content ">
                        <div dangerouslySetInnerHTML={ {__html: blogItem.body} } />
                    </div>
                </div>
            </section>
        </>
    )
}
export default SingleBlog;